export function isCombo(props) {
  return props.items != null || (props.lookupModel != null && props.cacheLookup === true);
}

export function isAutoComplete(props) {
  return props.lookupModel != null && props.cacheLookup !== false;
}
